import React from "react";

interface VideoRecordingDurationGraphDataProps {}

export const VideoRecordingDurationGraphData: React.FC<VideoRecordingDurationGraphDataProps> = () => {
  return <div></div>;
};
